module.exports = __webpack_public_path__ + "img/skip.9a703b30.png";